import { createNavigation } from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ["en", "ar"] as const,
  // Used when no locale matches
  defaultLocale: "en" as const,
  localePrefix: "always",
  pathnames: {
    "/": {
      en: "/",
      ar: "/",
    },
    "/example": {
      en: "/example",
      ar: "/مثال",
    },
    "/cart": {
      en: "/cart",
      ar: "/cart",
    },
    "/about": {
      en: "/about",
      ar: "/about",
    },

    "/services": {
      en: "/services",
      ar: "/services",
    },

    "/services/[id]": {
      en: "/services/[id]",
      ar: "/services/[id]",
    },

    "/products/product-details": {
      en: "/products/product-details",
      ar: "/products/product-details",
    },
    // for test
    "/request-for-employment": {
      en: "/request-for-employment",
      ar: "/request-for-employment",
    },

    "/contact": {
      en: "/contact",
      ar: "/contact",
    },
    "/auth/login": {
      en: "/auth/we-are-here-to-serve-you",
      ar: "/نحن-هنا-لخدمتك",
    },
    "/auth/register": {
      en: "/auth/join-us-and-feel-the-difference",
      ar: "/انضم-إلينا-واكتشف-روعة-منتجاتنا",
    },
    "/auth/verify": {
      en: "/auth/verify",
      ar: "/auth/verify",
    },
    "/projects": {
      en: "/projects",
      ar: "/projects",
    },
    "/shop": {
      en: "/shop",
      ar: "/shop",
    },
    "/user-account": {
      en: "/user-account",
      ar: "/user-account",
    },
    "/user-account/points": {
      en: "/user-account/points",
      ar: "/user-account/points",
    },
  },
});

export type ValidHref = keyof typeof routing.pathnames;

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export type Locale = (typeof routing.locales)[number];
export const { Link, redirect, usePathname, useRouter } =
  createNavigation(routing);
